<template lang="pug">
.edit-area
  textarea.textarea(@blur="finishEdit" @focus="startEdit" ref="textarea" v-model="text" rows="1" v-bind:placeholder="'Добавить ' + (typeof this.label != 'undefined' ? this.label : '')")
</template>

<script>
export default {
  name: 'edit-area',
  props: [
    'value',
    'label'
  ],
  data() {
    return {
      returnValue: ''
    }
  },
  created() {
    this.$nextTick(() => {
      this.autosize()
      this.returnValue = this.value
      this.$refs.textarea.addEventListener('keydown', this.autosize)
    })
  },
  computed: {
    text: {
      get() {
        return this.value
      },
      set(value) {
        this.returnValue = value
      }
    }
  },
  methods: {
    startEdit() {
      this.returnValue = this.value
    },
    finishEdit() {
      this.$emit('input', this.returnValue)
      this.$emit('finish')
    },
    autosize() {
      this.$refs.textarea.style.cssText = 'height:auto;';
      this.$refs.textarea.style.cssText = 'height:' + (this.$refs.textarea.scrollHeight + 2) + 'px';
    },
    focus() {
      this.$nextTick(() => {
        this.$refs.textarea.focus()
      })
    },
    getValue() {
      this.$emit('input', this.returnValue)
    }
  },
  watch: {
    'returnValue'() {
      this.$nextTick(() => {
        this.autosize()
      })
    }
  }
}
</script>

<style scoped lang="sass">
.edit, .textarea
  background: inherit
  line-height: inherit
  white-space: pre-wrap
  transition: background .3s
  border-radius: 2px
  cursor: text
  padding: 5px
  margin: -5px
  border: 1px solid transparent
  letter-spacing: normal
.textarea
  font: inherit
  width: calc(100% + 10px)
  outline: none
  resize: none
  overflow: hidden
  &:hover, &:focus
    background: rgba(0, 0, 0, .05)
  &:focus
    border-color: rgba(0, 0, 0, .05)
</style>


// WEBPACK FOOTER //
// EditArea.vue?7296c792